/**
 * Web counterpart of the friend-seeding share action. There is no share sheet,
 * so the profile link goes to the clipboard.
 *
 * A rejected clipboard write (denied permission, insecure context) is non-fatal
 * — the step is optional either way.
 */
export async function shareProfileLink(shareUrl: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(shareUrl);
  } catch {
    // Clipboard unavailable or denied - non-fatal.
  }
}
